import styled from 'styled-components'
import { Col, Row } from 'antd'

export const StyledRow = styled(Row)`
  min-height: 200px;
`

export const NoData = () => {
  return (
    <StyledRow justify="center" align="middle">
      <Col>No hay información para esta combinación de filtros.</Col>
    </StyledRow>
  )
}
